import { render, staticRenderFns } from "./BubbleAction.vue?vue&type=template&id=112236f2&scoped=true&"
import script from "./BubbleAction.vue?vue&type=script&lang=ts&"
export * from "./BubbleAction.vue?vue&type=script&lang=ts&"
import style0 from "./BubbleAction.vue?vue&type=style&index=0&id=112236f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112236f2",
  null
  
)

export default component.exports